import React, { useCallback } from 'react';
import styled from 'astroturf/react';
import UnionIcon from 'js/design_system/icons/union.svg';
import { Button } from 'js/design_system/Button';
import { Heading } from 'js/design_system/Heading';
import _SignupBannerContainer from "SignupBanner-SignupBannerContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/SignupBanner.tsx?styleId=SignupBannerContainer";
import _SignupBannerContent from "SignupBanner-SignupBannerContent.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/SignupBanner.tsx?styleId=SignupBannerContent";
import _SignupBannerMessage from "SignupBanner-SignupBannerMessage.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/SignupBanner.tsx?styleId=SignupBannerMessage";
import _SignupBannerButton from "SignupBanner-SignupBannerButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/build_vu/interstitials/SignupBanner.tsx?styleId=SignupBannerButton";


// Lazy load openLoginModal to avoid pulling LoginModal into server bundle
// LoginModal is only needed when user clicks the button, not during SSR
const loadOpenLoginModal = async () => {
  const { openLoginModal } = await import('js/login_modal/LoginModalManager');
  return openLoginModal;
};

const SignupBannerContainer = /*#__PURE__*/styled("div", null, {
  displayName: "SignupBannerContainer",
  styles: _SignupBannerContainer
});

const SignupBannerContent = /*#__PURE__*/styled("div", null, {
  displayName: "SignupBannerContent",
  styles: _SignupBannerContent
});

const SignupBannerMessage = /*#__PURE__*/styled(Heading, null, {
  displayName: "SignupBannerMessage",
  styles: _SignupBannerMessage
});

const SignupBannerButton = /*#__PURE__*/styled(Button, null, {
  displayName: "SignupBannerButton",
  styles: _SignupBannerButton
});

export const SignupBanner: React.FC = () => {
  // Claude recommended I use useCallback to ensure the function reference stays the same between renders
  const handleSignupClick = useCallback(
    async (_e: React.MouseEvent<HTMLButtonElement>) => {
      if (typeof window === 'undefined') {
        return;
      }

      const openLoginModal = await loadOpenLoginModal();

      openLoginModal({
        postLoginRedirectUrl: window.location.href,
        clickTrackingContext: {
          source: 'loswp--signup-banner',
        },
        registrationParams: {
          user_source: 'download',
        },
      });
    },
    [],
  );

  return (
    <SignupBannerContainer>
      <SignupBannerContent>
        <UnionIcon size={80} />
        <SignupBannerMessage>
          Download research papers for <strong>free!</strong>
        </SignupBannerMessage>
      </SignupBannerContent>
      <SignupBannerButton
        size="lg"
        onClick={handleSignupClick}
        iconRight="arrow_forward"
      >
        Join us!
      </SignupBannerButton>
    </SignupBannerContainer>
  );
};
